import { HttpClient } from '@angular/common/http';
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { catchError, map, Observable, of } from 'rxjs';

@Pipe({
  name: 'srcSecurePipe',
  standalone: true,
})
export class SrcSecurePipePipe implements PipeTransform {
  constructor(private http: HttpClient, private sanitizer: DomSanitizer) {}

  transform(url: string, errorUrl = ''): Observable<SafeUrl> {
    return this.http.get(url, { responseType: 'blob' }).pipe(
      map(val => this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(val))),
      catchError(() => {
        return of(errorUrl);
      }),
    );
  }
}
